// extracted by mini-css-extract-plugin
export default {"headingWrapper":"u8M13aUO--styles_headingWrapper__FyQ0+","expiredTag":"u8M13aUO--styles_expiredTag__fn64o","shimmer":"u8M13aUO--styles_shimmer__TiJjV"};